module.exports = __webpack_public_path__ + "img/logo.61871c33.png";